/* ------------------------------------------------------------------
// TODO: esbuild移行時に命名やimportできるようにリファクタリング必要
--------------------------------------------------------------------- */
const accordion = $(".jsAccordion");
accordion.each(function () {
  $(this)
    .find(".jsAccordionSwitch")
    .click(function () {
      $(this).next(".jsContentWrap").slideToggle();
    });
});

$(".jsAccordionSwitch").on("click", function () {
  if ($(this).hasClass("jsAccordionOpening")) {
    $(this).removeClass("jsAccordionOpening accordionOpening");
    $(this).addClass("jsAccordionClosing accordionClosing");
  } else {
    $(this).addClass("jsAccordionOpening accordionOpening");
    $(this).removeClass("jsAccordionClosing accordionClosing");
  }
});
